import {
  Chip,
  Flex,
  FlexColumn,
  StatusChip,
} from '@elementary/common-ui/components';
import { pluralizeString } from '@elementary/common-ui/utils/common';
import { Typography } from '@mui/material';
import SamplesTable from 'shared/components/SamplesTable';
import { fontSize, fontWeight } from '@elementary/common-ui/style/utils';
import { CustomSqlPreviewStatus } from './customSqlCloudTest';

type Props = {
  columns: string[];
  rows: Array<Record<string, unknown>>;
  status: CustomSqlPreviewStatus;
};

const CustomQueryResultsPreview = ({ columns, rows, status }: Props) => (
  <FlexColumn sx={{ gap: 1, minHeight: 0 }}>
    <Flex sx={{ alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      <Typography sx={{ fontWeight: fontWeight('semibold') }}>
        Results
      </Typography>
      <Chip
        label={pluralizeString(rows.length, 'row', 'rows')}
        size="small"
        variant="outlined"
      />
      <StatusChip status={status} size="small" />
      <Typography sx={{ color: 'content.secondary', fontSize: fontSize('sm') }}>
        Preview — sample of failing rows
      </Typography>
    </Flex>
    <SamplesTable
      data={rows}
      columns={columns.map((column) => ({
        id: column,
        display_name: column,
      }))}
      maxHeight={220}
    />
  </FlexColumn>
);

export default CustomQueryResultsPreview;
